import styled from 'styled-components'

import { StyledRowContainer, StyledRowItem } from 'components/Form/helpers/FormRow/FormRowStyled'
import { StyledLeftContainer } from 'components/Field/InlineEdit/InlineEditStyled'

export const StyledWrapper = styled.div`
  margin: 25px 0 0;

  ${StyledRowItem} {
    min-height: 0;
  }

  ${StyledRowContainer} {
    margin: 0;
  }

  ${StyledLeftContainer} {
    min-height: 32px;
    display: flex;
    align-items: center;
  }
`
